import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

import { CloseIcon } from '../../Icon';

const StyledWrapper = styled.div``;
const StyledCloseIconWrapper = styled.span`
  width: 30px;
  height: 30px;
  top: -2rem;
  left: -2rem;
  padding: 4px;
  position: relative;
  z-index: 99;
  background: #327388;
  display: inline-block;
  border-radius: 50%;
  cursor: pointer;
`;

const StyledCaption = styled.div`
  text-align: center;
  font: normal normal 300 14px/20px Lato;
  letter-spacing: 0.28px;
  color: #242325;
  margin: 0 auto 2rem;
  min-height: 20px;
  
  @media (max-width: 767px) {
    max-height: 300px;
    overflow-y: scroll;
  }
`;

type Props = {
  modalIsOpen: boolean;
  openModal: () => void;
  closeModal: () => void;
  description: string | void;
};

export const HelpTextModal = ({
  modalIsOpen,
  openModal,
  closeModal,
  description,
}: Props) => {
  if (!description) {
    return null;
  }

  const customStyles = {
    overlay: {
      zIndex: 1063,
      backgroundColor: 'rgb(36,35,37, 0.25)',
    },
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      width: 'calc(100% - 4rem)',
      transform: 'translate(-50%, -50%)',
      border: '3px solid #327388',
      borderRadius: '10px',
      padding: '10px',
      overflow: 'visible',
    },
  };

  Modal.setAppElement('#root');

  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
    >
      <StyledWrapper>
        <StyledCloseIconWrapper onClick={closeModal}>
          <CloseIcon />
        </StyledCloseIconWrapper>
        {description && (
          <StyledCaption dangerouslySetInnerHTML={{ __html: description }} />
        )}
      </StyledWrapper>
    </Modal>
  );
};
